import gql from 'graphql-tag';

const mutation = gql`
  mutation SaveOnboardingSettings(
    $sex: SexType
    $age: Int
    $height: UserMeasurementHeightInputType
    $weight: UserMeasurementWeightInputType
    $goalWeight: UserMeasurementWeightInputType
    $dietMode: DietModeType
    $triangleOfPower: DietTriangleOfPowerInputType
    $activityLevel: DietActivityLevelType
    $spontaneousActivityLevel: SpontaneousActivityLevelType
    $preferredMacronutrientRatio: MacronutrientRatioInputType
    $dietId: Int
    $dietType: DietOxyDietTypeType
    $exclusions: Int
    $muscleGroups: [MuscleGroupTypeEnum]
    $workoutLocation: [WorkoutLocationTypeEnum]
    $motivations: [MotivationEnum]
    $nutritionPreferences: [DietSourceEnum]
    $dietSource: DietSourceEnum
    $strengthTrainingExperience: StrengthTrainingExperienceEnum
    $hashimotoConditions: [HashimotoConditionEnum]
    $hashimotoSymptoms: [HashimotoSymptomEnum]
    $hashimotoGlp1Usage: HashimotoGlp1UsageEnum
    $hashimotoTsh: Float
    $preferredInstructors: [Int]
    $customAttributes: [CustomAttributeInputType]
  ) {
    me {
      saveOnboardingSettings(
        sex: $sex
        age: $age
        height: $height
        weight: $weight
        goalWeight: $goalWeight
        dietMode: $dietMode
        triangleOfPower: $triangleOfPower
        activityLevel: $activityLevel
        spontaneousActivityLevel: $spontaneousActivityLevel
        preferredMacronutrientRatio: $preferredMacronutrientRatio
        dietId: $dietId
        dietType: $dietType
        exclusions: $exclusions
        muscleGroups: $muscleGroups
        workoutLocation: $workoutLocation
        motivations: $motivations
        nutritionPreferences: $nutritionPreferences
        dietSource: $dietSource
        strengthTrainingExperience: $strengthTrainingExperience
        hashimotoConditions: $hashimotoConditions
        hashimotoSymptoms: $hashimotoSymptoms
        hashimotoGlp1Usage: $hashimotoGlp1Usage
        hashimotoTsh: $hashimotoTsh
        preferredInstructors: $preferredInstructors
        customAttributes: $customAttributes
      ) {
        ... on BasicMutationSuccess {
          code
          __typename
        }
        ... on UnauthorizedException {
          code
          __typename
        }
        ... on ValidationException {
          code
          __typename
          messages
          details {
            fieldName
            messages
          }
        }
      }
    }
  }
`;

export default mutation;
